/* Original Renegade conversion, cart and compatibility fixes */
(function () {
  'use strict';

  function safeText(value) {
    return String(value || '').replace(/[&<>]/g, function (m) {
      if (m === '&') return '&amp;';
      if (m === '<') return '&lt;';
      return '&gt;';
    });
  }

  window.showToast = window.showToast || function (title, sub) {
    var toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<div class="toast__title">' + safeText(title) + '</div>' + (sub ? '<div class="toast__sub">' + safeText(sub) + '</div>' : '');
    toast.classList.add('is-visible');
    clearTimeout(toast._orTimer);
    toast._orTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  };

  window.updateCartCount = window.updateCartCount || function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.site-header__cart-count').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.setAttribute('aria-label', cart.item_count + ' items in cart');
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        document.querySelectorAll('.site-header__cart-wrap a').forEach(function (link) {
          link.setAttribute('aria-label', 'Cart (' + cart.item_count + ' items)');
        });
        return cart;
      });
  };

  function syncCartItemQuantity(row) {
    if (!row) return;
    var remove = row.querySelector('.cart-item__remove');
    var input = row.querySelector('.cart-item__qty-val');
    if (!remove || !remove.dataset.key || !input) return;
    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = quantity;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: remove.dataset.key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.showToast('Cart update failed', 'Please refresh and try again.'); });
  }

  document.addEventListener('click', function (event) {
    var qtyButton = event.target.closest('.cart-item__qty-btn');
    if (!qtyButton) return;
    var row = qtyButton.closest('.cart-item');
    window.setTimeout(function () { syncCartItemQuantity(row); }, 0);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.cart-item__qty-val')) return;
    syncCartItemQuantity(event.target.closest('.cart-item'));
  });
})();